import React, { useMemo } from "react";
import { Layout, Menu } from "antd";
import {
	CalendarOutlined,
	HomeOutlined,
	IdcardOutlined,
	AuditOutlined,
	SettingOutlined,
	SolutionOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Sider } = Layout;

const MENU_ITEMS = [
	{
		type: "group",
		label: "근태현황",
		children: [
			{
				key: "/attendance/monthly",
				icon: <CalendarOutlined />,
				label: "월별현황",
			},
			{
				key: "/attendance/daily",
				icon: <CalendarOutlined />,
				label: "일별현황",
			},
			{
				key: "/attendance/user",
				icon: <CalendarOutlined />,
				label: "교직원별 현황",
			},
			{
				key: "/attendance/dawn-worship",
				icon: <CalendarOutlined />,
				label: "새벽예배 현황",
			},
		],
	},
	{
		type: "group",
		label: "복무 신청 관리",
		children: [
			{
				key: "/attendance/leave-applications",
				icon: <SolutionOutlined />,
				label: "신청 관리",
			},
			{
				key: "/attendance/leave-balance",
				icon: <SolutionOutlined />,
				label: "잔여 연차 관리",
			},
			{
				key: "/attendance/leave-plans",
				icon: <SolutionOutlined />,
				label: "연차 사용계획 관리",
			},
			{
				key: "/attendance/holiday-half-day",
				icon: <SolutionOutlined />,
				label: "공휴일 반차 관리",
			},
		],
	},
	{
		type: "group",
		label: "결재 관리",
		children: [
			{
				key: "/attendance/approval-routes",
				icon: <AuditOutlined />,
				label: "결재 순서 관리",
			},
			{
				key: "/attendance/approval-assignments",
				icon: <AuditOutlined />,
				label: "적용 인원 지정",
			},
		],
	},
	{
		type: "group",
		label: "교직원 정보 관리",
		children: [
			{
				key: "/member/manage-employee-info",
				icon: <IdcardOutlined />,
				label: "교직원 정보 설정",
			},
			{
				key: "/member/manage-employee-teams",
				icon: <IdcardOutlined />,
				label: "직원 팀 관리",
			},
			{
				key: "/member/assign-employee-team-members",
				icon: <IdcardOutlined />,
				label: "팀별 멤버 지정",
			},
		],
	},
	{
		type: "group",
		label: "설정",
		children: [
			{
				key: "/attendance/settings",
				icon: <SettingOutlined />,
				label: "설정",
			},
		],
	},
];

const LEAF_KEYS = MENU_ITEMS.flatMap((item) =>
	item.children ? item.children.map((child) => child.key) : [],
);

const AttendanceNavigation = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const selectedKey = useMemo(() => {
		const path =
			(location.pathname || "/").replace(/\/+$/, "") || "/";
		const found = LEAF_KEYS.find((key) => key === path);
		if (found) {
			return found;
		}
		if (path.startsWith("/attendance/daily")) {
			return "/attendance/daily";
		}
		if (path.startsWith("/attendance/user")) {
			return "/attendance/user";
		}
		if (path.startsWith("/attendance/dawn-worship")) {
			return "/attendance/dawn-worship";
		}
		if (path.startsWith("/attendance/leave-applications")) {
			return "/attendance/leave-applications";
		}
		if (path.startsWith("/attendance/leave-balance")) {
			return "/attendance/leave-balance";
		}
		if (path.startsWith("/attendance/holiday-half-day")) {
			return "/attendance/holiday-half-day";
		}
		if (path.startsWith("/attendance/approval-routes")) {
			return "/attendance/approval-routes";
		}
		if (path.startsWith("/attendance/approval-assignments")) {
			return "/attendance/approval-assignments";
		}
		if (path.startsWith("/member/manage-employee-info")) {
			return "/member/manage-employee-info";
		}
		if (path.startsWith("/member/manage-employee-teams")) {
			return "/member/manage-employee-teams";
		}
		if (path.startsWith("/member/assign-employee-team-members")) {
			return "/member/assign-employee-team-members";
		}
		if (path.startsWith("/attendance/settings")) {
			return "/attendance/settings";
		}
		return "/attendance/monthly";
	}, [location.pathname]);

	return (
		<Sider
			width={260}
			className="member-navigation__sider attendance-navigation"
			breakpoint="lg"
			collapsedWidth="0">
			<div className="member-navigation__logo">
				<HomeOutlined />
				<span>교직원 근태관리</span>
			</div>
			<Menu
				mode="inline"
				theme="dark"
				selectedKeys={[selectedKey]}
				items={MENU_ITEMS}
				onClick={({ key }) => {
					if (String(key).startsWith("/")) {
						navigate(key);
					}
				}}
				className="member-navigation__menu attendance-navigation__menu"
			/>
		</Sider>
	);
};

export default AttendanceNavigation;
